/**
 * "View DX codes" menu action: analytics + opens clinical data table modal.
 *
 * @module handleViewDxCodes
 */
import {
  AuthOnFile,
  GeneralOrderDetails,
} from "../../../../data-model/medicalPaOrdersModel";
import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import { ModalId } from "../../../../enums/modalId";
import { getAllJCodesFromAuthOnFile } from "../../../../pages/singleOrderLayout/utils/existingDocsToLs";
import { formatJcodeIcdFromAuthOnFile } from "../../../../pages/singleOrderLayout/utils/getJCode";
import { setOpenedModalId } from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";

/** Parameters for {@link handleViewDxCodes}. */
export interface HandleViewDxCodesParams {
  dispatch: AppDispatch;
  generalOrderDetails: GeneralOrderDetails;
  authOnFile: AuthOnFile;
  orgId: string;
  userId: string;
  userEmail: string;
  payerName: string;
  primaryIcdCodes: string;
  /** BigQuery screen name attached to the analytics event. */
  screenName: ScreenNamesForBigQuery;
}

/**
 * Handles the "View DX Codes" action.
 * Opens the clinical data table modal and logs the event.
 *
 * @param params - Parameters for the action
 */
export const handleViewDxCodes = ({
  dispatch,
  generalOrderDetails,
  authOnFile,
  orgId,
  userId,
  userEmail,
  payerName,
  primaryIcdCodes,
  screenName,
}: HandleViewDxCodesParams): void => {
  apiWorkerManager.enqueueAndProcess({
    patient_id:
      generalOrderDetails?.demographics?.patient_id ??
      generalOrderDetails?.demographics?.patient_mrn ??
      "",
    order_id: generalOrderDetails?.order_id ?? "",
    org_id: orgId ?? "",
    event_name: EventsName.VIEW_DX_CODES_CLICKED,
    user_id: userId,
    user_email: userEmail,
    additional_data: {
      screen_name: screenName,
      payer_name: payerName,
      j_code: getAllJCodesFromAuthOnFile(authOnFile ?? undefined)
        ?.map((jCode) => jCode.j_code)
        .join(","),
      assigned_primary_icd_code: primaryIcdCodes,
      jcode_icd: formatJcodeIcdFromAuthOnFile(authOnFile),
    },
  });

  dispatch(setOpenedModalId({ id: ModalId.CLINICAL_DATA_TABLE }));
};
